var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('span',[_vm._t("default")],2),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"dropdown",style:(_vm.ddStyle)},[_vm._t("dropdown")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }